import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=38cac016&"
import script from "./QuestionHeader.vue?vue&type=script&lang=js&"
export * from "./QuestionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports